// Action Types

/**
 * createTypes is a function to create CONSTANT action types instead of regular strings to prevent typo mistakes.
 * @param  {array} strings
 */
function createTypes(strings, ...types) {
  types = [...strings, types];
  types = types.join("\n");
  types = types.split("\n");
  const TYPES = {};
  for (let type of types) {
    if (type === "") {
      continue;
    }
    TYPES[type] = type;
  }
  return TYPES;
}

/**
 * createOurSteps is a function to create the four types for given action.
 * @method
 * @param {string} PREFEX - The PREFEX for each generated type.
 */
function createSteps(PREFEX) {
  const OUR_STEPS = ["loading", "success", "fail"];

  const OUR_STEP_CREATED = [PREFEX.toUpperCase()];

  OUR_STEPS.forEach((STEP) =>
    OUR_STEP_CREATED.push(`${PREFEX}_${STEP}`.toUpperCase())
  );

  return OUR_STEP_CREATED.join("\n");
}

const types = [
  "SEND_MESSAGE",
  "GET_MESSAGES",
  "GET_ALL_MESSAGES",
  "GET_LAST_MESSAGE",
  "GET_REPLIES",
  "GET_MESSAGE_DETAILS",
  "MARK_MESSAGE_READ",
  "MARK_ALL_MESSAGES_READ",
];

export default createTypes`${types.map(createSteps).join("\n")}`;

export const CLEAR_SEND_MESSAGE_SUCCESS = "CLEAR_SEND_MESSAGE_SUCCESS";
export const CLEAR_LAST_MESSAGE = "CLEAR_LAST_MESSAGE";
export const CLEAR_MARK_MESSAGE_READ_SUCCESS = "CLEAR_MARK_MESSAGE_READ_SUCCESS";
export const CLEAR_MARK_ALL_MESSAGE_READ_SUCCESS = "CLEAR_MARK_ALL_MESSAGE_READ_SUCCESS";
export const CLEAR_MESSAGE_REPLIES = "CLEAR_MESSAGE_REPLIES";

